module.exports = __webpack_public_path__ + "static/media/videoCameraActive.02a51fad.svg";